/**
 * @generated SignedSource<<2548aa4515f968d0b1237390d3ae22a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutKlarnaPayment_transaction$data = {
  readonly buyerInvoice: {
    readonly invoiceItems: ReadonlyArray<{
      readonly code: string | null;
      readonly totalAmount: {
        readonly amount: number | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "CheckoutKlarnaPayment_transaction";
};
export type CheckoutKlarnaPayment_transaction$key = {
  readonly " $data"?: CheckoutKlarnaPayment_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutKlarnaPayment_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutKlarnaPayment_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Invoice",
      "kind": "LinkedField",
      "name": "buyerInvoice",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "InvoiceItem",
          "kind": "LinkedField",
          "name": "invoiceItems",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "totalAmount",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "amount",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "bbdd593c8c91045b2f5d35f55338e6de";

export default node;
